var map = {
	"./elisa.svg": "t0lu",
	"./houston.svg": "4EkI",
	"./konecranes.svg": "yeQS",
	"./smartly_io.svg": "sVR9",
	"./sympa.svg": "KuEl",
	"./terveystalo.svg": "q4zM",
	"./unity.svg": "nWgS",
	"./uoh.svg": "xaKB"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GIXk";